import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-lg border-2 border-wood-dark bg-cta font-display font-black uppercase leading-tight tracking-wide text-charcoal text-center shadow-cta transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-cta-pressed';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm',
    lg: 'px-4 py-3.5 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-197" data-mp="1h6kwdl8447hs">
      {children}
    </a>;
}